if (!customElements.get('landing-cans-product-form')) {
  customElements.define(
    'landing-cans-product-form',
    class extends HTMLElement {
      constructor() {
        super();
        
        this.productSection = this.closest('#landing-product');
        this.productForm = this.querySelector('form');
        this.purchaseTypeOptions = this.productForm?.querySelectorAll('input[name="selling_plan"]');
        this.submitButton = this.querySelector('button[type="submit"]');
      }

      connectedCallback() {
        const navEntry = performance.getEntriesByType('navigation')[0];
        if (navEntry && navEntry.type === 'back_forward') {
            window.location.reload();
        }

        this.setEventListeners();
        this.removeNoSwipingFromGallery();
      }

      setEventListeners() {
        if (this.submitButton && this.productForm) {
          this.submitButton.addEventListener('click', event => this.onSubmit(event));
        }

        this.purchaseTypeOptions?.forEach(option => {
          option.addEventListener('change', () => {
            const selectedType = option.value == '' ? 'onetime' : 'subscription';
            this.toggleAdditionalTextByPurchaseType(selectedType);
          });
        })
      }

      toggleAdditionalTextByPurchaseType(purchaseType = 'subscription') {
        if (!this.productSection) return;

        const additionalTextElements = this.productSection.querySelectorAll('[data-purchase-type]:not([data-purchase-type="both"])');
        additionalTextElements.forEach(element => {
          const isCurrentType = element.dataset.purchaseType === purchaseType;
          element.style.display = isCurrentType ? 'block' : 'none';
        });
      }
      
      removeNoSwipingFromGallery() {
        this.productSection?.querySelectorAll('li.slider__media-item').forEach(slide => {
          slide.classList.remove('swiper-no-swiping');
        })
      }

      async addItemToCart() {
        if (!this.productForm) return;

        document.dispatchEvent(new Event('theme:loading:start'));

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.productForm);
        if(localStorage.getItem('first-visited-page')){
          formData.append('properties[_first_visited_page]', localStorage.getItem('first-visited-page'));
        }
        config.body = formData;

        try {
            await fetch('/cart/clear.js');
            const response = await fetch(`${routes.cart_add_url}`, config);
            const data = await response.json();

            this.trackEvents(data);

            if (data.status === 422) {
                if(!document.getElementById('sold-out-error-message')) {
                    const errorElement = document.createElement('p');
                    errorElement.innerText = data.message;
                    errorElement.id = 'sold-out-error-message';
                    errorElement.style.color = "var(--color-red-text, #d6121a)";
                    this.productForm.appendChild(errorElement);
                }
                throw new Error(data.message);
            }

            if (!!config.body.get('discount')) {
              const updateConfig = fetchConfig('javascript');
              updateConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete updateConfig.headers['Content-Type'];

              const updateData = new FormData();
              updateData.append('discount', config.body.get('discount'));
              updateConfig.body = updateData;

              await fetch(`${routes.cart_update_url}.js`, updateConfig)
            }

            if (data) window.location.href = '/checkout';
        } catch (error) {
            console.error(error);
        } finally {
          document.dispatchEvent(new Event('theme:loading:end'))
        }
      }

      onSubmit(event) {
        event.preventDefault();
        this.addItemToCart();
      }

      trackEvents(data) {
        const { product_title, product_id, variant_id, discounted_price, original_price, featured_image, url, vendor, quantity } = data;
        const price = (discounted_price * quantity) / 100;
        const compareAtPrice = (original_price * quantity) / 100;

        window.klaviyoItem = {
            Name: product_title,
            ProductID: product_id,
            Categories: product_title,
            ImageURL: featured_image?.url || '',
            URL: `${window.location.origin}/products/${url}`,
            Brand: vendor,
            Price: window.theme.moneyFormat?.replace('{{amount}}', price),
            CompareAtPrice: window.theme.moneyFormat?.replace('{{amount}}', compareAtPrice)
        };

        if (typeof klaviyoItem !== 'undefined') {
            klaviyo.push(['track', 'Added to Cart', window.klaviyoItem]);
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'add_to_cart',
            atc_value: price,
            items: [{
                id: `shopify_US_${product_id}_${variant_id}`,
                google_business_vertical: 'retail'
            }]
        });
      }
    }
  );
}